import type { RunMetricOutput } from "@/types/RunMetricOutput"

import { TranscriptSignalMetricRecord } from "./TranscriptSignalMetricRecord"

export class AgentRefusalMetricRecord extends TranscriptSignalMetricRecord {
  getHeaderValue(mo: RunMetricOutput[]): string | null {
    // % of calls where the agent refused (YES); 0% is healthy.
    return this.getFailureRateHeaderValue(mo)
  }
}
